import { SplashScreen } from '@capacitor/splash-screen';
import { DeviceStatusBar } from '../support/DeviceStatusBar';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useEffect } from 'react';

export const DismissSplashScreen: React.FC<{ children: any }> = ({ children }) => {

    let statusBar: DeviceStatusBar | undefined;
    try {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        statusBar = useInstance(DeviceStatusBar);
    } catch (e: any) {
        // this component is used both inside and outside AppContainer, so we may not be able to get it
    }

    useEffect(() => {
        setTimeout(async () => {

            await SplashScreen.hide();

            // on android 12+, status bar is blocked by the splash screen,
            // and needs a nudge to repaint itself
            if (statusBar) {
                await statusBar.repaintAndroid();
            }

        }, 100);
    }, [statusBar]);

    return children;
};
